export default {
  app: {
    privacy: {
      policy: 'Tietosuojakäytäntö',
      expansive: 'Käyttämällä Expansivea hyväksyt Expansiven {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Istunto vanhentunut',
    sessionExpiredDescription:
      'Istuntosi on vanhentunut. Kirjaudu sisään uudelleen jatkaaksesi sovelluksen käyttöä.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Valitse kieli',
      chooseLanguageDescription:
        'Valitse haluamasi kieli sovellukselle. Tämä muuttaa käyttöliittymän ja sisällön kielen.',
    },
    userSelection: {
      cancel: 'Peruuta',
      createNewUser: 'Heidän nimeään ei ole listalla',
      newUser: 'Uusi käyttäjä',
      selectAnExistingUser: 'Valitse olemassa oleva käyttäjä',
      selectUserHint: 'Valitse olemassa oleva käyttäjä tai luo uusi jatkaaksesi.',
      startTypingToSearch: 'Aloita kirjoittaminen...',
    },
    verification: {
      codeVerification: {
        continue: 'Jatka',
        header: 'Syötä sivuston pääsytunnus',
        invalidCode: 'Virheellinen koodi, yritä uudelleen.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Jatka ilman sijainnin vahvistusta',
        enterSiteAccessCode: 'Syötä sivuston pääsytunnus',
        locationNotEnabledOrAvailable: 'Miksi näen tämän?',
        notAvailable: {
          description: 'GPS-sijaintia ei tueta tässä laitteessa.',
          header: 'Sijaintia ei tueta',
        },
        notEnabled: {
          description: 'Sijaintipalvelut eivät ole käytössä tai lupa ei ole myönnetty.',
          header: 'Sijainti ei ole käytössä',
        },
        notVerified: {
          description: 'GPS osoittaa, ettet ole paikan päällä.',
          header: 'Sijaintia ei vahvistettu',
        },
        tryAgain: 'Yritä uudelleen',
        unavailable: {
          description: 'Emme voineet vahvistaa GPS-sijaintiasi.',
          header: 'Sijainti ei saatavilla',
        },
        unknown: {
          description: 'Emme pysty määrittämään sijaintiasi.',
          header: 'Sijainti tuntematon',
        },
        verified: {
          description: 'GPS osoittaa, että olet paikan päällä.',
          header: 'Sijainti vahvistettu',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Ei löytynyt omaisuutta',
        emptyDescription: 'Tähän työtilaukseen ei ole liitetty omaisuutta.',
        warrantyParts: 'Osien takuu päättyy',
        serialNumber: 'Sarjanumero',
        none: '<ei mitään>',
      },
      updates: {
        emptyTitle: 'Ei löytynyt päivityksiä',
        emptyDescription: 'Tälle työtilaukselle ei ole päivityksiä.',
        unknownUser: 'Tuntematon käyttäjä',
        none: 'Ei mitään',
        addComment: {
          buttonLabel: 'Lisää kommentti',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Vaarat',
          no: 'Ei',
          yes: 'Kyllä',
        },
      },
    },
    attachmentsList: {
      attachments: 'Liitteet',
      documents: 'Asiakirjat',
      siteDocuments: 'Sivuston asiakirjat',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Vaarat',
        induction: 'Aloitus',
        safeToProceed: 'Turvallista edetä',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Eräpäivä',
        activeSessions: 'Aktiiviset istunnot',
        activeSessionsDescription:
          'Olet jo kirjautunut seuraaviin työtilauksiin. Sinun on poistuttava näistä työtilauksista ennen kuin voit kirjautua uuteen työtilaukseen.',
        resumeSession: 'Jatka',
        startTime: 'Aloitettu',
        unexpectedErrorTitle: 'Odottamaton virhe',
        unexpectedErrorMessage:
          'Odottamaton virhe tapahtui, kun yritettiin luoda istuntojasi. Yritä myöhemmin uudelleen.',
        engineerNotFound: 'Insinööriä ei löytynyt',
        engineerNotFoundDescription:
          'Insinööriä, jota yrität kirjata sisään, ei löydy järjestelmästä. Ota yhteyttä järjestelmänvalvojaan.',
      },
      verification: {
        code: {
          description:
            'Kirjautuaksesi sisään, pyydä 4-numeroinen koodi sivuston päälliköltä tai nimetyltä yhteyshenkilöltä.',
        },
        geo: {
          continue: 'Jatka',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Pyydä pääsykoodi paikan vastuuhenkilöltä tai nimetyltä yhteyshenkilöltä vieraasi päätökseen.',
            checkOut: 'Kirjaudu ulos',
            completeBeforeLeaving: 'Täytä seuraava lomake ennen lähtöä.',
            continue: 'Jatka',
            noResolutionSelected: 'Valitse ratkaisu ennen jatkamista.',
            quoteRequired: {
              hint: 'Vierailu valmis, tarjous seuraa',
              label: 'Tarjous vaaditaan',
            },
            returnVisitRequired: {
              hint: 'Palaamme vielä kerran täydentämään',
              label: 'Paluuvierailu vaaditaan',
            },
            serviceCompleted: {
              hint: 'Ei lisätoimenpiteitä vaadita',
              label: 'Palvelu suoritettu',
            },
            uploadCheckout: 'Lataa tiedosto, valokuva tai video',
            visitNotes: 'Vierailun muistiinpanot',
            workOrderResolution: 'Työtilauksen ratkaisu',
            enterNotes: 'Syötä muistiinpanot tähän...',
            errors: {
              timedOut: 'Aikakatkaisu, 30 sekuntia ylittyi. Yritä uudelleen.',
              closingSession: 'Virhe sulkiessa istuntoa',
            },
          },
          success: {
            description:
              'Kiitos vierailustasi {site}. | {site}ssa on vielä 1 avoin työtilaus. | {site}ssa on vielä {count} avointa työtilausta.',
            endVisit: 'Päätä vierailu',
            header: 'Olet onnistuneesti kirjautunut ulos',
            viewWorkOrders: 'Kirjaudu toiseen työtilaukseen',
          },
          verification: {
            code: {
              description:
                'Kirjautuaksesi ulos, pyydä 4-numeroinen koodi sivuston päälliköltä tai nimetyltä yhteyshenkilöltä.',
              continue: 'Jatka',
            },
            geo: {
              checkOut: 'Kirjaudu ulos',
              continue: 'Jatka',
            },
          },
        },
        detail: {
          assets: 'Omaisuus',
          call: 'Soita',
          checkOut: 'Kirjaudu ulos',
          closed: 'Suljettu',
          details: 'Yksityiskohdat',
          dueBy: 'Eräpäivä',
          manageEngineers: 'Hallitse insinöörejä',
          notAvailable: 'Ei saatavilla',
          pointOfContact: 'Yhteyshenkilö',
          siteAccessTimes: 'Sivuston pääsytiedot',
          siteAccessInstructions: 'Pääsyohjeet',
          siteAddress: 'Sivuston osoite',
          siteNotes: 'Sivuston muistiinpanot',
          siteTelephone: 'Sivuston puhelin',
          siteLocation: 'Sivuston sijainti',
          updates: 'Päivitykset',
          more: 'Lisää',
          mismatchErrorTitle: 'Työtilauksen virhe',
          mismatchErrorMessage:
            'Yrität käyttää työtilausta, joka ei vastaa sitä, johon olet tällä hetkellä kirjautuneena. Tarkista työtilauksesi ja yritä uudelleen.',
          siteDocuments: 'Sivuston asiakirjat',
          validFrom: 'Voimassa alkaen',
          validUntil: 'Voimassa asti',
          documentName: 'Asiakirjan nimi',
          documentType: 'Asiakirjan tyyppi',
          attachments: 'Työtilauksen tiedostot',
          download: 'Lataa',
          workDetails: 'Työn yksityiskohdat',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Lisää apuinsinööri',
            assistantEngineers: 'Apuinsinöörit',
            description: 'Turvallisuussyistä, ilmoita jokaisen työmaalla olevan insinöörin nimet.',
            editMainEngineer: 'Muokkaa pääinsinööriä',
            errors: {
              creatingEngineer: 'Virhe luotaessa insinööriä',
              creatingSession: 'Virhe luotaessa istuntoa',
            },
            header: 'Työmaalla olevat insinöörit',
            mainEngineer: 'Pääinsinööri',
            newAssistantEngineer: 'Syötä heidän koko nimensä',
            next: 'Seuraava',
            removeEngineer: 'Poista insinööri',
            selectExistingAssistantEngineer: 'Aloita kirjoittaminen heidän nimensä',
          },
          index: {
            description: 'Turvallisuussyistä, ilmoita jokaisen työmaalla olevan insinöörin nimet.',
            errorCreatingEngineer: 'Virhe luotaessa insinööriä, yritä uudelleen.',
            header: 'Työmaalla olevat insinöörit',
            hintMainEngineer: 'Syötä pääinsinöörin koko nimi',
            newMainEngineer: 'Uusi pääinsinööri',
            next: 'Seuraava',
            selectExistingMainEngineer: 'Valitse olemassa oleva pääinsinööri',
            yes: 'Kyllä',
            no: 'Ei',
            mainEngineerLabel: 'Oletko sinä pääinsinööri?',
          },
        },
        index: {
          callUsOn: 'Soita meille numeroon {phoneNumber}',
          description: 'Etkö löydä etsimääsi?',
          dueBy: 'Eräpäivä',
          header: 'Valitse työtilaus',
          notAvailable: 'Ei saatavilla',
          searchWorkOrders: 'Hae työtilauksia...',
        },
        manageEngineers: {
          manageEngineers: 'Hallitse insinöörejä',
          notWorking: 'Passiiviset työntekijät',
          pause: 'Pysäytä',
          resume: 'Jatka',
          workingNow: 'Aktiiviset työntekijät',
          startTime: 'Aloitusaika',
          endTime: 'Lopetusaika',
          duration: 'Kesto',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Palaute',
            feedbackDescription:
              'Ole hyvä ja anna palautetta työtilauksesta auttaaksesi meitä parantamaan palvelujamme.',
            feedbackLabel: 'Palaute',
            filesLabel: 'Liitteet',
            submissionLabel: 'Lähetä palaute',
          },
          hazards: {
            back: 'Palaa takaisin',
            hazards: 'Vaarat',
            next: 'Seuraava',
            no: 'Ei',
            noTasksForHazard: 'Tälle vaaralle ei ole suoritettavia tehtäviä.',
            yes: 'Kyllä',
          },
          induction: {
            continue: 'Jatka',
            induction: 'Aloitus',
          },
          index: {
            checkIn: 'Kirjaudu sisään',
            description: 'Ole hyvä ja täytä seuraava riskinarviointi valitulle työlle.',
            fail: 'Työtilauksen tarkistusten käsittely epäonnistui.',
            haltMessage:
              'Mahdolliset riskit havaittu. Keskeytä työ, tarkista turvallisuusohjeet ja ota yhteyttä valvojaasi lisäohjeita varten.',
            header: 'Työn tarkistukset',
            endVisit: 'Päätä vierailu',
            leaveFeedback: 'Jätä palaute',
          },
          safeToProceed: {
            continue: 'Jatka',
            safeToProceed: 'Turvallista edetä',
          },
        },
      },
    },
    index: {
      title: 'Tervetuloa',
      description: 'Skannaa sijainnissasi oleva QR-koodi aloittaaksesi.',
    },
    login: {
      errorTitle: 'Odottamaton virhe',
      errorMessage: 'Odottamaton virhe tapahtui. Yritä skannata QR-koodi uudelleen.',
    },
    unauthenticated: {
      welcome: {
        title: 'Tervetuloa {site}',
        description:
          'Ennen kuin voimme näyttää sinulle työtilauksia, meidän on vahvistettava tietosi. Klikkaa alla olevaa painiketta jatkaaksesi.',
        next: 'Jatka',
      },
      index: {
        errorTitle: 'Odottamaton virhe',
        errorMessage: 'Odottamaton virhe tapahtui. Yritä skannata QR-koodi uudelleen.',
      },
      contractor: {
        title: 'Kenelle työskentelet?',
        contractor: 'Urakoitsija',
        contractorLabel: 'Aloita kirjoittamalla yrityksesi nimi',
        contractorHint: 'Sinun on syötettävä vähintään 3 merkkiä nähdäksesi tulokset',
        defaultSelectPlaceholder: '--Valitse--',
        next: 'Seuraava',
      },
      user: {
        title: 'Kuka olet?',
        cancel: 'Peruuta',
        createNewUserLabel: 'Nimeni ei ole listalla',
        existingUserLabel: 'Aloita kirjoittamalla nimesi',
        existingUserHint: 'Sinun on syötettävä vähintään 3 merkkiä nähdäksesi tulokset',
        newUserLabel: 'Syötä koko nimesi',
        next: 'Seuraava',
        user: 'Käyttäjä',
      },
      verification: {
        methods: {
          add: {
            add: 'Lisää vahvistusmenetelmä',
            defaultSelectPlaceholder: '--Valitse--',
            emailLabel: 'Sähköposti',
            existingMethodWarning:
              'Sinulla on jo odottava pyyntö tälle vahvistusmenetelmälle, joka odottaa järjestelmänvalvojan hyväksyntää. Uuden lisääminen korvataan.',
            method: 'Menetelmä',
            methodLabel: 'Menetelmä',
            mobileCountryHint: 'Valitse maakohtainen koodisi',
            mobileCountryLabel: 'Mobiilimaan koodi',
            mobileHint: 'Syötä mobiilinumero',
            mobileLabel: 'Mobiili',
            title: 'Lisää vahvistusmenetelmä',
          },
          confirm: {
            confirm: 'Vahvista',
            description: 'Vahvista vahvistusmenetelmäsi jatkaaksesi.',
            label: 'Syötä koodisi',
            resend: 'Lähetä uudelleen',
            resendPrompt: 'Et saanut koodia?',
            title: 'Vahvista vahvistusmenetelmä',
          },
          confirmed: {
            description:
              'Saat ilmoituksen, kun tämä vahvistusmenetelmä on hyväksytty järjestelmänvalvojasi toimesta, ja voit sitten alkaa käyttää sitä henkilöllisyytesi vahvistamiseen.',
            forceApproval: 'Kunnes se on hyväksytty, et voi käyttää työtilauksia.',
            nonForceApproval:
              'Samaan aikaan voit jatkaa työtilauksiin pääsyä rajoitetulla pääsyllä.',
            nonForceApprovalButtonLabel: 'Jatka rajoitetulla pääsyllä',
            title: 'Odottaa hyväksyntää',
          },
          addNew: 'Lisää uusi vahvistusmenetelmä',
          description:
            'Meidän on vahvistettava henkilöllisyytesi, jotta voimme antaa sinulle täydet oikeudet työtilaukseen.',
          email: 'Sähköposti',
          hint: 'Lähetämme linkin valitsemallesi vahvistusmenetelmälle, joka antaa sinulle täydet oikeudet työtilaukseen. Jos sinun tarvitsee muuttaa mitään olemassa olevia vahvistusmenetelmiä, ota yhteyttä järjestelmänvalvojaan.',
          label: 'Valitse vahvistusmenetelmä',
          next: 'Seuraava',
          pendingHint: 'Odottaa hyväksyntää järjestelmänvalvojaltasi',
          sms: 'SMS',
          title: 'Vahvistus',
        },
        optional: {
          hint: 'Käyttäjätietojesi vahvistaminen antaa sinulle täydet oikeudet työtilaukseen',
          label: 'Haluatko vahvistaa käyttäjätietosi?',
          next: 'Seuraava',
          no: 'Ei',
          noHint:
            'En halua vahvistaa käyttäjätietojani ja jatkaa rajoitetuilla oikeuksilla työtilaukseen',
          title: 'Vahvistus',
          yes: 'Kyllä',
          yesHint: 'Haluan vahvistaa käyttäjätietoni ja saada täydet oikeudet työtilaukseen',
        },
        sent: {
          description:
            'Sisäänkirjautumislinkki on lähetetty osoitteeseen {identifier}. Klikkaa linkkiä täydentääksesi sisäänkirjautumisesi.',
          title: 'Sisäänkirjautumislinkki lähetetty',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Eilen',
      today: 'Tänään',
      days: {
        monday: 'Maanantai',
        tuesday: 'Tiistai',
        wednesday: 'Keskiviikko',
        thursday: 'Torstai',
        friday: 'Perjantai',
        saturday: 'Lauantai',
        sunday: 'Sunnuntai',
      },
      months: {
        january: 'Tammikuu',
        february: 'Helmikuu',
        march: 'Maaliskuu',
        april: 'Huhtikuu',
        may: 'Toukokuu',
        june: 'Kesäkuu',
        july: 'Heinäkuu',
        august: 'Elokuu',
        september: 'Syyskuu',
        october: 'Lokakuu',
        november: 'Marraskuu',
        december: 'Joulukuu',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Jokin meni pieleen',
      message: 'Yritä skannata QR-koodi uudelleen.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Tuntematon käyttäjä',
      },
      none: 'Ei mitään',
      types: {
        stateTransition: 'Tila muuttunut',
        contractorAssigned: 'Urakoitsija назначен',
        engineerAssigned: 'Insinööri назначен',
        serviceAssigned: 'Palvelu назначен',
        priorityChanged: 'Prioriteetti muuttunut',
        actionableDateChanged: 'Toimeenpanopäivämäärä muuttunut',
        dueDateChanged: 'Eräpäivä muuttunut',
        etaDateChanged: 'Arvioitu saapumisaika muuttunut',
        spendLimitApproved: 'Kuluraja hyväksytty',
        spendLimitCancelled: 'Kuluraja peruttu',
        spendLimitRejected: 'Kuluraja hylätty',
        spendLimitRequested: 'Kuluraja pyydetty',
        jobSheetUploaded: 'Työraportti ladattu',
        slaAlertSent: 'Aika huomautus lähetetty',
        issuedWorkPermit: 'Työlupa myönnetty',
        requestForServiceSent: 'Palvelupyyntö lähetetty',
        comment: 'Kommentti lisätty',
        unknown: 'Tuntematon tapahtuma',
      },
      labels: {
        actionableDate: 'Toimeenpanopäivämäärä',
        comment: 'Kommentti',
        file: 'Tiedosto',
        contractor: 'Urakoitsija',
        dueDate: 'Eräpäivä',
        etaDate: 'Arvioitu saapumisaika',
        engineer: 'Insinööri',
        priority: 'Prioriteetti',
        requestForService: 'Palvelupyyntö',
        service: 'Palvelu',
        spendLimit: 'Kuluraja',
        status: 'Tila',
        workPermit: 'Työlupa',
      },
    },
  },
}
